// T12.a: our own /api/media assets have responsive WebP variants (?w=); external URLs are used as-is
export const isOurs = (src) => /\/api\/media\/[^/?]+$/.test(src || "");
export const sized = (src, w) => (isOurs(src) ? `${src}?w=${w}` : src);
export const srcSetOf = (src) => (isOurs(src) ? `${sized(src, 640)} 640w, ${sized(src, 1024)} 1024w` : undefined);
export const altOf = (name, i, n) => (n > 1 ? `${name} - image ${i + 1} of ${n}` : name);
